/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Container, Title } from "./styles";
import { MDBRow, MDBCol } from "mdb-react-ui-kit";
import InputWithMaskBlocked from "../../components/InputWithMaskBlocked";
import InputBlocked from "../../components/InputBlocked";
import Input from "../../components/Input";
import RedButton from "../../components/RedButton";
import CheckboxLabels from "../../components/Checkbox";
import { useParams } from "react-router-dom";
import api from "../../services/api";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Multiline from "../../components/Multiline";

import { useNavigate } from "react-router-dom";

const CadastroModeloSaida = () => {
  const navigate = useNavigate();

  const [nomeModeloSaida, setNomeModeloSaida] = useState("");

  const handleNomeModeloSaida = (event) => {
    setNomeModeloSaida(event);
  };

  useEffect(() => {
    const role = localStorage.getItem("role");
    const token = localStorage.getItem("token");

    if (!token || role !== "ADMIN") {
      navigate("/login");
    }
  }, [navigate]);

  const formSubmit = (event) => {
    event.preventDefault();

    const data = {
      nome: nomeModeloSaida,
    };

    api
      .post("/outputDevices", data)
      .then((response) => {
        toast.success("Modelo novo de venda cadastrado com sucesso!");
        navigate("/menuModeloSaida");
      })
      .catch((error) => {
        console.error("Erro: ", error);
        if (error.response) {
          if (error.response.status === 404 || error.response.status === 400) {
            toast.warning(`${error.response.data.error}`);
          } else {
            toast.error(`${error.response.data.error}`);
          }
        } else {
          toast.error("Erro interno de servidor. Por favor, tente novamente!");
        }
      });
  };

  return (
    <Container>
      <MDBRow style={{ width: "100%", justifyContent: "center" }}>
        <MDBCol xg={6} lg={6} md={8} sm={12}>
          <form onSubmit={formSubmit}>
            <Title className="text-center">
              <h3>Cadastro de modelo novo</h3>
            </Title>
            <MDBRow>
              <MDBCol md={12} className="text-start">
                <label>Modelo a ser vendido</label>
                <Input
                  onChange={(event) => handleNomeModeloSaida(event)}
                  password={false}
                />
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <RedButton onClick={() => navigate("/menuModeloSaida")}>
                <strong>Voltar</strong>
              </RedButton>
              <RedButton onClick={formSubmit}>
                <strong>Cadastrar</strong>
              </RedButton>
            </MDBRow>
          </form>
        </MDBCol>
      </MDBRow>
    </Container>
  );
};

export default CadastroModeloSaida;
